import {IApplicationState} from '../../../types/types';

export const getListName = (
    state: IApplicationState,
    listId: number
): string => {
    return state.model.lists[listId] && state.model.lists[listId].name;
};
